import OfferCard from './components/SellerOfferCard';

import { useEffect, useState } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import { useNavigate } from 'react-router-dom';
import { getImage } from 'variables/images';
import { useDisclosure } from '@chakra-ui/hooks';
import SuccessModal from './components/SuccessModal';
import KYCBanner from 'components/KYCBanner';

const MyOfferIntegrate = () => {
    // const [offers, setOffers] = useState([]);
    const [user, setUser] = useState(null);
    const [myOffers, setMyOffers] = useState([]);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const nav = useNavigate();

    const initUser = () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/user/me`, config)
            .then((res) => {
                setUser(res.data);
                if (res.data && res.data.type !== 'seller') {
                    window.location.href = '/my-request';
                }
                console.log(res.data);
            })
            .catch((err) => {
                console.log('No user info found', err);
            });
    };

    const initMyOffer = () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/seller-offer/mine`, config)
            .then((res) => {
                setMyOffers(res.data);
                console.log(res.data);
            })
            .catch((err) => {
                console.log('No user info found', err);
                window.location.href = '/auth/sign-in';
            });
    };



    useEffect(() => {
        if (
            !localStorage.getItem('token') ||
            localStorage.getItem('token').length < 10
        )
            window.location.href = '/auth/sign-up';

        const urlParams = new URLSearchParams(window.location.search);
        const created = urlParams.get('created');
        if (created === 'true' && !isOpen) {
            onOpen();
        }

        initMyOffer();
        initUser();
    }, []);

    return (
        <div className="flex flex-col gap-6">
            <div className="rounded-xl border border-leadrs-stroke bg-white p-6">
                <p className="font-geist text-xs font-semibold uppercase tracking-widest text-leadrs-text-soft">Vendeur</p>
                <h1 className="mt-1 font-crimson text-4xl font-semibold leading-tight text-leadrs-text">Integration</h1>
                <p className="mt-2 font-geist text-sm text-leadrs-text-soft">
                    Apres l&apos;integration, vos leads seront automatiquement envoyes a Leadrs depuis votre CMS.
                </p>
            </div>

            <KYCBanner user={user} onUserRefresh={initUser} />
            <SuccessModal isOpen={isOpen} onClose={onClose} />

            <div>
                <div className="mb-4 flex items-center justify-end">
                    <button
                        className="rounded-lg bg-leadrs-brand px-4 py-2 font-geist text-sm font-medium text-white transition-opacity hover:opacity-80"
                        onClick={() => nav('/seller-offer')}
                    >
                        Ajouter une offre
                    </button>
                </div>
                <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
                    {myOffers.map((offer) => (
                        <OfferCard
                            id={offer._id}
                            key={offer._id}
                            channels={offer.channels}
                            offerNumber={offer.offerNumber}
                            title={offer.subIndustry}
                            author={offer.industry}
                            status={offer.status}
                            tested={offer.tested}
                            isArchived={offer.status === 'done'}
                            price={offer.buyerPrice}
                            weeklyQuantity={offer.weeklyQuantity}
                            image={getImage(offer.industry, offer.subIndustry)}
                            onClick={() => nav(`/offer/${offer._id}`)}
                        />
                    ))}
                </div>
                {myOffers.length === 0 && (
                    <div className="flex flex-col items-center gap-4 py-12">
                        <p className="font-geist text-sm text-leadrs-text-soft">Vous n&apos;avez pas encore d&apos;offre.</p>
                        <button
                            className="rounded-lg bg-leadrs-brand px-6 py-2.5 font-geist text-sm font-medium text-white transition-opacity hover:opacity-80"
                            onClick={() => nav('/seller-offer')}
                        >
                            Creer ma premiere offre
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MyOfferIntegrate;
